import Initial from '../../../components/Initial'
import Panel, { PanelBody } from '../../../components/Panel'
import useInitial from '../useInitial'
import FilterRoles from './FilterRoles'
import TableRoles from './TableRoles'

export default function Roles() {
    const state = useInitial()

    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <FilterRoles />
                    <TableRoles />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
